var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPurchaseFinanceProductIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1836_15717)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9458,
    height: 16.9458,
    rx: 8.4729,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 27.5713 10.4736)",
    fill: "#009DD7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.9458,
    height: 16.9458,
    rx: 8.4729,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 49.4465 32.4402)",
    fill: "#3E4CB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8169 17.0729C45.7056 15.8037 45.2751 13.9689 43.8554 12.9748L41.2848 11.1749C39.8651 10.1808 37.9938 10.4038 37.1051 11.673L15.2208 42.927C14.3321 44.1962 14.7626 46.031 16.1823 47.025L18.7529 48.825C20.1726 49.8191 22.0439 49.596 22.9326 48.3269L44.8169 17.0729Z",
    fill: "url(#paint0_linear_1836_15717)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1836_15717",
    x: 8.62549,
    y: 9.47363,
    width: 42.821,
    height: 42.9725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1836_15717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1836_15717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1836_15717",
    x1: 37.1468,
    y1: 9.26247,
    x2: 28.7078,
    y2: 34.2806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#009DD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#009DD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#3E4CB4"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPurchaseFinanceProductIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/purchase-finance-product-icon.fd5155bb.svg";
export { ForwardRef as ReactComponent };